import axios from 'axios'
import Utils from '@/common/utils'

const url = `${process.env.VUE_APP_BASE_API}/api`
const headers = { Authorization: Utils.setLocalToken() }

export default class FactoringDocumentService {
  static async getDocuments (params) {
    const { data } = await axios.get(`${url}/factoringDocument/`, { headers, params })
    return data
  }

  static async update (invoice) {
    const { data } = await axios.put(`${url}/factoringDocument/${invoice.documentId}`, invoice, { headers })
    return data
  }

  static async preSell (payload) {
    const { data } = await axios.post(`${url}/presell/`, payload, { headers })
    return data
  }

  static async setPaymentReference (payload) {
    const { data } = await axios.post(`${url}/factoringDocument/setPaymentReference/`, payload, { headers })
    return data
  }

  static async setAsPreSell (payload) {
    const { data } = await axios.post(`${url}/factoringDocument/setAsPreSell/`, payload, { headers })
    return data
  }

  static async processPreSells (payload) {
    const { data } = await axios.post(`${url}/factoringDocument/processPreSells/`, payload, { headers })
    return data
  }

  static async deleteByUser (payload) {
    const { data } = await axios.post(`${url}/factoringDocument/deleteByUser/`, payload, { headers })
    return data
  }

  static async restoreByUser (payload) {
    const { data } = await axios.post(`${url}/factoringDocument/restoreByUser/`, payload, { headers })
    return data
  }

  static async requestAuthorization (payload) {
    const { data } = await axios.post(`${url}/factoringDocument/requestAuthorization/`, payload, { headers })
    return data
  }

  static async sendSummary (payload) {
    const { data } = await axios.post(`${url}/factoringDocument/sendSummary/`, payload, { headers })
    return data
  }

  static async getDocumentsPaymentInformation (params) {
    const { data } = await axios.get(`${url}/factoringDocument/getPaymentInformation`, { headers, params })
    return data
  }

  static async findOrCreate (payload) {
    const { data } = await axios.post(`${url}/factoringDocument/findOrCreate/`, payload, { headers })
    return data
  }

  static async nextPayments (params) {
    const { data } = await axios.get(`${url}/factoringDocument/nextPayments`, { headers, params })
    return data
  }
}
